define(['app/modules/forms'], function(Forms) {

  var testPage = $('.ca-test-page');

  var setTimer = function(el, time){
    el.setTime(time);
  };

  var setCircleProgress = function(el, text, options){
    el.circleProgress(options);
    el.find('.value').text(text);
  };

  var setCheckboxes = function(){
    $('.ca-test-question input.radio-icheck').iCheck({ handle: 'radio' });
  };

  var renderQuestion = function(el, html){
    el.html(html);
    setCheckboxes();
  };

  var nextExampleQuestion = function(question, result){
    var nextQuestion = question.next();
    question.addClass('answered');

    if(result.answer.correct){
      question.find('.result-icon').addClass('correct');
    } else {
      question.find('.result-icon').addClass('no-correct');
    }

    question.find('.form-actions').remove();
    question.find('.ca-test-answer-radio').attr('disabled', 'disabled');
    question.find('.ca-example-heading').removeClass('current');

    if(nextQuestion.length > 0){
      question.find('.ca-example-collapse').collapse('hide');
      nextQuestion.removeClass('disabled');
      nextQuestion.find('.ca-example-collapse').collapse('show');
      nextQuestion.find('.ca-example-heading').addClass('current');
    } else {
      testPage.find('.ca-example-collapse').collapse('show');
      $('html, body').animate({
        scrollTop: question.offset().top
      }, 1000);
    }
  };

  var setClock = function(el, testId){
    return el.find('.ca-test-timer').FlipClock({
      countdown: true,
      clockFace: 'MinuteCounter',
      callbacks: {
        stop: function() {
          finish(testId);
        }
      }
    });
  };

  var createAnswer = function(form, testTimer, testProgress){
    var answer = form.find('.ca-test-answer-radio:checked').val();

    $.ajax({
      type: 'POST',
      url: form.attr('action'),
      data: { test: { answer_id: answer } },
      success: function(result){
        if(result.status == 'ok'){
          setCircleProgress(testProgress, result.progress.text, { value: result.progress.value, animationStartValue: testProgress.circleProgress('value') });

          if(result.stop_timer){
            testTimer.stop();
          } else {
            setTimer(testTimer, result.time_left);
            renderQuestion(form.closest('.ca-test-question'), result.question_html);
          }
        } else {
          Forms.showErrors(form, result.errors, '_test', result.errors_html);
        }
      }
    });
  };

  var getQuestion = function(id, testTimer, testProgress){
    if(id){
      $.ajax({
        type: 'GET',
        url: '/tests/'+id+'/question',
        success: function(result){
          testPage.find('.ca-test-progress').removeClass('hidden');
          if(result.status == 'ok'){
            renderQuestion(testPage.find('.ca-test-question'), result.question_html);
            setTimer(testTimer, result.time_left);
            setCircleProgress(testProgress, result.progress.text, { value: result.progress.value, startAngle: (-Math.PI/2) });

            if(result.stop_timer){
              testTimer.stop();
            } else {
              testTimer.start();
            }
          }
        }
      });
    }
  };

  var finish = function(id){
    if(id){
      $.ajax({
        type: 'PUT',
        url: '/tests/'+id+'/finish',
        success: function(result){
          if(result.status == 'ok'){
            testPage.find('.ca-test-question').html(result.finish_html);
            testPage.find('.ca-test-timer.flip-clock-wrapper').addClass('finished');
            window.onbeforeunload = false;
          }
        }
      });
    }
  };

  var exampleAnswer = function(question){
    var answer = question.find('.ca-test-answer-radio:checked').val();
    var url = question.data('answer-url');

    if(answer) {
      $.ajax({
        type: 'POST',
        url: url,
        data: { test: { answer_id: answer } },
        success: function(result){
          if(result.status == 'ok'){
            nextExampleQuestion(question, result);
          }
        }
      });
    }
  };

  return {
    createAnswer: createAnswer,
    getQuestion: getQuestion,
    finish: finish,
    exampleAnswer: exampleAnswer,
    setClock: setClock
  };
});
